import * as CareerConstants from "../constants/career.constant";
import { Loading } from "../utils/helpers/constants";
import { deleteItemHelper } from "../utils/helpers/dataHelper";

const initialState = {
  jobs: [],
  scholarships: [],
  job: {},
  scholarship: {},
  jobLoading: false,
  scholarshipLoading: false,
  jobDeleteStatusState: false,
  scholarshipDeleteStatusState: false,
};

const setLoadingJob = (state, action) => {
  const actionLoading = { ...state.jobLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

// const setLoadingScholarship = (state, action) => {
//   const actionLoading = { ...state.scholarshipLoading };
//   const { loading, id } = action.payload;
//   actionLoading[id] = loading;
//   return actionLoading;
// };

const careerReducer = (state = initialState, action) => {
  const currentJobList = [...state.jobs];
  const currentScholarshipList = [...state.scholarships];

  switch (action.type) {
    case CareerConstants.CREATE_JOB_REQUEST:
      return { ...state, jobLoading: Loading.FETCHING };
    case CareerConstants.CREATE_JOB_SUCCESS:
      return {
        ...state,
        jobLoading: Loading.SUCCESS,
      };
    case CareerConstants.CREATE_JOB_FAILURE:
      return { ...state, jobLoading: Loading.FAILED };

    case CareerConstants.FETCH_ALL_JOB_REQUEST:
      return { ...state, jobLoading: Loading.FETCHING };
    case CareerConstants.FETCH_ALL_JOB_SUCCESS:
      return {
        ...state,
        jobs: action.payload.jobList,
        jobLoading: Loading.SUCCESS,
      };
    case CareerConstants.FETCH_ALL_JOB_FAILURE:
      return { ...state, jobLoading: Loading.FAILED };

    case CareerConstants.DELETE_JOB_REQUEST:
      return {
        ...state,
        jobDeleteStatusState: setLoadingJob(state, action),
      };
    case CareerConstants.DELETE_JOB_SUCCESS:
      const newList = deleteItemHelper(currentJobList, action.payload.id, "id");
      return {
        ...state,
        jobs: newList,
        jobDeleteStatusState: setLoadingJob(state, action),
      };
    case CareerConstants.DELETE_JOB_FAILURE:
      return {
        ...state,
        jobDeleteStatusState: setLoadingJob(state, action),
      };

    //SCHOLARSHIP
    case CareerConstants.CREATE_SCHOLARSHIP_REQUEST:
      return { ...state, scholarshipLoading: Loading.FETCHING };
    case CareerConstants.CREATE_SCHOLARSHIP_SUCCESS:
      return {
        ...state,
        scholarshipLoading: Loading.SUCCESS,
      };
    case CareerConstants.CREATE_SCHOLARSHIP_FAILURE:
      return { ...state, scholarshipLoading: Loading.FAILED };

    case CareerConstants.FETCH_ALL_SCHOLARSHIP_REQUEST:
      return { ...state, scholarshipLoading: Loading.FETCHING };
    case CareerConstants.FETCH_ALL_SCHOLARSHIP_SUCCESS:
      return {
        ...state,
        scholarships: action.payload.scholarshipList,
        scholarshipLoading: Loading.SUCCESS,
      };
    case CareerConstants.FETCH_ALL_SCHOLARSHIP_FAILURE:
      return { ...state, scholarshipLoading: Loading.FAILED };

    case CareerConstants.DELETE_SCHOLARSHIP_REQUEST:
      return {
        ...state,
        jobDeleteStatusState: setLoadingJob(state, action),
      };
    case CareerConstants.DELETE_SCHOLARSHIP_SUCCESS:
      const newScholarshipList = deleteItemHelper(
        currentScholarshipList,
        action.payload.id,
        "id"
      );
      return {
        ...state,
        scholarships: newScholarshipList,
        scholarshipDeleteStatusState: setLoadingJob(state, action),
      };
    case CareerConstants.DELETE_SCHOLARSHIP_FAILURE:
      return {
        ...state,
        scholarshipDeleteStatusState: setLoadingJob(state, action),
      };
    default:
      return state;
  }
};

export default careerReducer;
